import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'banner-container',
  styleUrl: 'banner-container.css',
  shadow: true,
})
export class BannerContainer {
  @Prop() showDesktop: boolean = false;

  render() {
    const bannerContainerClass = {
      'banner-container-block': true,
      'flex-col py-4 gap-0': !this.showDesktop,
      'flex-row box-border h-full py-3 gap-5': this.showDesktop,
    };
    return (
      <div class={bannerContainerClass}>
        <slot></slot>
      </div>
    );
  }
}
